import React from 'react';
import './heading.scss';

const Heading = () => {
	return (
		<div className="heading-wrapper">
			<h1>QR code generator</h1>
			<p>
				Generate QR code
			</p>
		</div>
	);

}

export default Heading;